<template>
    <div class="app_header" :data-bg="bgColor" id="myHeader">
        <div class="header_inner">

            <div class="header_news" v-if="page == 'home'" :data-tooltip-displayed="(displayedTooltip) ? 'true': 'false'">
                <div class="news_bt" @click="displayedTooltip = !displayedTooltip">Last Update</div>
                <div class="news_tooltip" :data-displayed="(displayedTooltip) ? 'true': 'false'">
                    <div class="tooltip_closebt" @click="hideTooltip()">Hide</div>
                    <div class="tooltip_date">
                        {{ fixedNewsData.date }}
                    </div>
                    <div class="tooltip_text" v-html="fixedNewsData.description"></div>
                    <div class="tooltip_link">
                        <a :href="fixedNewsData.link" target="_blank">Read more</a>
                    </div>
                </div>
            </div>

            <nuxt-link class="header_logo" to="/"></nuxt-link>
            <div class="header_sticky_title">{{stickyTitle}}</div>
            <div class="header_burgerbt" @click="mobileMenuDisplayed = !mobileMenuDisplayed" :class="(mobileMenuDisplayed) ? 'opened': ''"></div>
            <div class="header_menu" :data-mobiledisplayed="(mobileMenuDisplayed) ? 'true' : 'false'">
                <div class="header_head">
                    <nuxt-link class="header_logo" to="/"></nuxt-link>
                    <div class="header_burgerclosebt" @click="mobileMenuDisplayed = false"></div>
                </div>

                <div class="header_content">
                    <nuxt-link class="menu_item" to="/" data-item="home" :class="(page == 'home' && !expandMoreBlock) ? 'selected' : ''">
                        <span v-if="mobileMenuDisplayed">Homepage</span>
                    </nuxt-link>
                    <div class="menu_item" @click="clickMenuItem('dataset')" :class="(page == 'dataset' && !expandMoreBlock) ? 'selected' : ''">Datasets</div>
                    <div class="menu_item" @click="clickMenuItem('country')" :class="(page == 'country' && !expandMoreBlock) ? 'selected' : ''">Countries</div>
                    <nuxt-link class="menu_item" to="/download-data/" :class="(page == 'download' && !expandMoreBlock) ? 'selected' : ''">Download data & methodology</nuxt-link>
                    <a class="menu_item" v-if="!mobileMenuDisplayed" data-item="more" @click="expandMoreBlock = !expandMoreBlock" :class="(expandMoreBlock) ? 'selected' : ''">More</a>
                    <nuxt-link class="menu_item" v-if="mobileMenuDisplayed" to="/research-briefs/">Research briefs</nuxt-link>
                    <nuxt-link class="menu_item" v-if="mobileMenuDisplayed" to="/teaching-toolkit/">Teaching Toolkit</nuxt-link>
                    <nuxt-link class="menu_item" v-if="mobileMenuDisplayed" to="/about/">About</nuxt-link>
                    <a class="menu_item" v-if="mobileMenuDisplayed" @click="gotoContactBlock()">Contact</a>
                    <nuxt-link class="menu_item" v-if="mobileMenuDisplayed" to="/faq/">FAQ</nuxt-link>

                    <div class="menu_shareblock" v-if="mobileMenuDisplayed">
                        <div class="shareblock_title">Follow us on</div>
                        <div class="col_icons">
                            <a class="col_icon" data-icon="fb"></a>
                            <a class="col_icon" data-icon="in"></a>
                            <a class="col_icon" data-icon="tw"></a>
                            <a class="col_icon" data-icon="lk"></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header_moreblock" v-if="expandMoreBlock">
                <nuxt-link class="moreblock_link" to="/research-briefs/">Research briefs</nuxt-link>
                <nuxt-link class="moreblock_link" to="/teaching-toolkit/">Teaching Toolkit</nuxt-link>
                <nuxt-link class="moreblock_link" to="/about/">About</nuxt-link>
                <a class="moreblock_link" @click="gotoContactBlock()">Contact</a>
                <nuxt-link class="moreblock_link" to="/faq/">FAQ</nuxt-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        page:{
            default: function () {
                return 'home'
            }
        },
        bgColor: {
            default: function () {
                return 'white'
            }
        },
        stickyTitle: {
            default: function () {
                return ''
            }
        },
        latestNews: {
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            expandMoreBlock: false,
            mobileMenuDisplayed: false,
            $app: '',
            displayedTooltip: false,
            latestNewsDisplayed: {
                date: "18.09.2024",
                description: "Check out the exciting new updates to The Atlas of the Offshore World! We've added features to help you explore how global profit shifting and offshore wealth impact economies. With new country-specific data, you can see how effective tax rates, profit shifting, and offshore wealth shape the economic landscape of individual nations. Stay informed with interactive visuals and updated analysis to better understand these complex global dynamics. Dive into the data today to discover how the offshore world impacts economies worldwide!",
                link: "https://www.taxobservatory.eu/atlas-offshore-world-updates/"
            },
            fixedNewsData: {
                date: "14.04.2026",
                description: "We updated the series on Global Profit Shifting by Multinational Enterprises",
                link: "https://www.nmbu.no/en/research/skatteforsk-tax-center/wp-38-global-profit-shifting-1975-2023"
            }
        }
    },
    mounted: function () {
        this.$app = document.getElementById('app');
        var localStorageNews = localStorage.getItem("atlas-offshore-world-news-profit-shifting-2026");
        if(localStorageNews != "true"){
            this.displayedTooltip = true;
        }

    },
    methods: {
        clickMenuItem: function (type){
            this.$emit('headerMenuClicked', type);
        },

        gotoContactBlock: function (){
            this.expandMoreBlock = false;
            const element = document.getElementById("SectionContact");
            const yOffset = -100;  // Adjust this to the desired offset
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        },

        hideTooltip: function (){
            localStorage.setItem("atlas-offshore-world-news-profit-shifting-2026", "true")
            this.displayedTooltip = false;
        }
    },

    watch: {
        mobileMenuDisplayed: function (){
            if(this.mobileMenuDisplayed) this.$app.classList.add("mobilemenudisplayed");
            else this.$app.classList.remove("mobilemenudisplayed");
        },

        latestNews: function (){
            this.latestNewsDisplayed = JSON.parse(JSON.stringify(this.latestNews));
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~assets/scss/_variables.scss";
@import "~assets/scss/_browsers.scss";

.app_header{
    position: relative;
    left: 0px;
    top: 0px;
    height: 120px;
    width: 100%;
    text-align: center;
    z-index: 500;
    &[data-bg="blue"]{
        background: $colorBlue;
        color: #fff;
        box-shadow: 0px 2.767256498336792px 2.2138051986694336px 0px rgba(33, 56, 135, 0.04), 0px 6.650102138519287px 5.32008171081543px 0px rgba(33, 56, 135, 0.06), 0px 12.521552085876465px 10.017241477966309px 0px rgba(33, 56, 135, 0.08), 0px 22.3363094329834px 17.869047164916992px 0px rgba(33, 56, 135, 0.09), 0px 41.777610778808594px 33.422088623046875px 0px rgba(33, 56, 135, 0.11), 0px 100px 80px 0px rgba(33, 56, 135, 0.15);
        .header_inner{
            
            .header_burgerbt{
                background: url("/images/burger.svg") no-repeat 0 0;
                background-size: 100% 100%;
                &.opened{
                    background: url("/images/close.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                }
            }
            .header_logo{
                background: url("/images/atlas_of_global_tax_avoidance-white.svg") no-repeat 0 0;
                background-size: 100% 100%;
            }
            .header_menu{
                .menu_item{
                    color: #fff;
                    &:after{
                        background: url("/images/arrow-back.svg") no-repeat 0 0;
                        background-size: 100% 100%;
                    }
                    &[data-item="home"]{
                        background: url("/images/home.svg") no-repeat 0 0;
                        background-size: 100% 100%;
                    }
                    &.selected{
                        &:before{
                            background: #fff;
                            top: 68px;
                        }
                    }
                }
            }
            .header_moreblock{
                background: $colorBlue;
                margin-top: 0px;
                .moreblock_link{
                    color: #fff;
                }
            }
        }
    }
    .header_inner{
        max-width: 1160px;
        height: 100%;
        width: 100%;
        position: relative;
        display: inline-block;
        border-bottom: 1px solid #29264C;

        .header_news{
            position: absolute;
            right: 0px;
            top: 100%;
            color: #29264C;

            &[data-tooltip-displayed="false"]{
                .news_bt{
                    background: #EEF1F6;
                    border: 2px solid $colorOrange;
                    &:hover{
                        background: #29264C;
                        border: 2px solid #29264C;
                        color: #fff;
                    }
                }
            }

            .news_bt{
                background: $colorOrange;
                border: 2px solid $colorOrange;
                text-transform: uppercase;
                font-weight: 700;
                height: 26px;
                padding: 0 12px;
                border-radius: 12px;
                line-height: 24px;
                cursor: pointer;
                right: 10px;
                position: absolute;
                top: -13px;
                white-space: nowrap;
            }
            .news_tooltip{
                background: $colorOrange;
                padding: 16px 24px;
                border-radius: 20px;
                width: 495px;
                position: absolute;
                right: 20px;
                top: 34px;
                text-align: left;
                font-size: 14px;
                display: none;
                &[data-displayed="true"]{
                    display: block;
                }
                .tooltip_closebt{
                    position: absolute;
                    right: 24px;
                    font-size: 12px;
                    top: 16px;
                    letter-spacing: 1.2px;
                    padding-right: 20px;
                    cursor: pointer;
                    &:after{
                        content: "";
                        position: absolute;
                        right: 0px;
                        top: 50%;
                        transform: translate(0, -50%);
                        background: url("/images/close-blue.svg") no-repeat;
                        background-size: 100% 100%;
                        width: 20px;
                        height: 20px;
                    }
                }
                .tooltip_date{

                }
                .tooltip_text{
                    margin-top: 10px;
                    line-height: 18px;
                    a{
                        color: #29264C;
                    }
                }
                .tooltip_link{
                    margin-top: 10px;
                    a{
                        color: #29264C;
                        text-decoration: underline;
                    }
                }

                &:after{
                    content: "";
                    position: absolute;
                    right: 30px;
                    bottom: 100%;
                    width: 0;
                      height: 0;
                      border-style: solid;
                      border-right: 11px solid transparent;
                      border-left: 11px solid transparent;
                      border-bottom: 16px solid $colorOrange;
                      border-top: 0;
                }
            }
        }


        .header_burgerbt{
            background: url("/images/burger-blue.svg") no-repeat 0 0;
            background-size: 100% 100%;
            width: 40px;
            height: 40px;
            position: absolute;
            right: 40px;
            top: 50%;
            display: none;
            cursor: pointer;
            transform: translate(0, -50%);
            &.opened{
                background: url("/images/close-blue.svg") no-repeat 0 0;
                background-size: 100% 100%;
            }
        }
        .header_logo{
            cursor: pointer;
            display: block;
            background: url("/images/atlas_of_global_tax_avoidance.svg") no-repeat 0 0;
            background-size: 100% 100%;
            width: 213.5px;
            height: 51px;
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translate(0, -50%);
        }
        .header_sticky_title{
            display: none;
            position: absolute;
            left: 0px;
            top: 50%;
            transform: translate(0, -50%);
            font-size: 12px;
            letter-spacing: 1.2px;
            color: #fff;
            background: $colorBlack;
            border-radius: 12px;
            height: 24px;
            line-height: 24px;
            padding: 0 12px;
        }
        .header_moreblock{
            position: absolute;
            right: 0px;
            top: 100%;
            background: #E6E9F0;
            color: #fff;
            padding: 6px 24px;
            text-align: left;
            margin-top: 1px;
            box-shadow: 0px 0px 1.7517952919006348px 0px rgba(40, 24, 88, 0.08), 0px 0px 4.430421829223633px 0px rgba(40, 24, 88, 0.11), 0px 0px 9.037644386291504px 0px rgba(40, 24, 88, 0.14), 0px 0px 18.6158390045166px 0px rgba(40, 24, 88, 0.18), 0px 0px 51px 0px rgba(40, 24, 88, 0.31);
            .moreblock_link{
                font-size: 16px;
                line-height: 26px;
                color: $colorBlue;
                display: block;
                height: 30px;
                cursor: pointer;
                text-decoration: none;
            }
        }
        .header_menu{
            z-index: 100;
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translate(0, -50%);
            width: 60%;
            text-align: right;
            &[data-mobiledisplayed="false"]{
                .header_head{
                    display: none;
                }
            }
            .menu_shareblock{
                display: block;
                text-align: left;
                margin-top: 14px;
                .shareblock_title{
                    font-size: 12px;
                    letter-spacing: 1.2px;
                    color: #BAC6DF;
                    text-transform: uppercase;
                }
                .col_icons{
                    margin-top: 14px;
                }
            }
            .menu_item{
                cursor: pointer;
                display: inline-block;
                vertical-align: top;
                color: $colorBlue;
                padding: 0 26px 0 0;
                margin-right: 20px;
                font-size: 16px;
                position: relative;
                text-decoration: none;
                &[data-item="home"]{
                    background: url("/images/home-blue.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                    width: 20px;
                    height: 20px;
                    margin-right: 30px;
                    &:after{
                        display: none;
                    }
                }
                &[data-item="more"]{
                    margin-right: 0px;
                    &:after{
                        transform: translate(0, -50%) rotate(135deg);
                    }
                    &.selected{
                        &:after{
                            transform: translate(0, -50%) rotate(215deg);
                        }
                    }
                }
                &:after{
                    content: "";
                    width: 21px;
                    height: 20px;
                    background: url("/images/arrow-back-blue.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                    position: absolute;
                    right: 0px;
                    top: 50%;
                    transform: translate(0, -50%) rotate(180deg);
                }
                &.selected{
                    &:before{
                        content: "";
                        width: 100%;
                        height: 3px;
                        background: $colorBlue;
                        position: absolute;
                        left: 0px;
                        top: 68px;
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// components/appHeader.vue